import { t as _objectSpread2 } from "./objectSpread2-BNmiQYyW.js";
import { t as DocSearchButton } from "./DocSearchButton-CaxxOzQU.js";
import { t as _objectWithoutProperties } from "./objectWithoutProperties-phqYxDS0.js";
import { t as DocSearchAskAiModal } from "./DocSearchAskAiModal-ByqIW5ZA.js";
import { t as DocSearchModal } from "./DocSearchModal-CITTG0fe.js";
import { version } from "./version.js";
import { DocSearchAI, DocSearchAIInner } from "./docsearchAi.js";
import { useDocSearchKeyboardEvents } from "./useDocSearchKeyboardEvents.js";
import { DocSearch as DocSearch$1, useDocSearch } from "@docsearch/core";
import React from "react";
import { createPortal } from "react-dom";

//#region src/DocSearch.tsx
const _excluded = ["appId", "apiKey"];
function DocSearchComponent(_ref, ref) {
	let { appId, apiKey } = _ref, props = _objectWithoutProperties(_ref, _excluded);
	return /* @__PURE__ */ React.createElement(DocSearch$1, _objectSpread2(_objectSpread2({}, props), {}, {
		appId,
		apiKey,
		ref
	}), /* @__PURE__ */ React.createElement(DocSearchInner, props));
}
const DocSearch = React.forwardRef(DocSearchComponent);
function DocSearchInner(props) {
	var _props$translations, _props$translations2, _props$portalContaine;
	const { searchButtonRef, keyboardShortcuts, isModalActive, initialQuery, openModal, closeModal, appId, apiKey } = useDocSearch();
	if (!appId || !apiKey) throw new Error("`DocSearch` requires `appId` and `apiKey` props.");
	return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DocSearchButton, {
		keyboardShortcuts,
		ref: searchButtonRef,
		translations: (_props$translations = props.translations) === null || _props$translations === void 0 ? void 0 : _props$translations.button,
		onClick: openModal
	}), isModalActive && createPortal(/* @__PURE__ */ React.createElement(DocSearchModal, _objectSpread2(_objectSpread2({}, props), {}, {
		appId,
		apiKey,
		initialScrollY: window.scrollY,
		initialQuery,
		translations: props === null || props === void 0 || (_props$translations2 = props.translations) === null || _props$translations2 === void 0 ? void 0 : _props$translations2.modal,
		onClose: closeModal
	})), (_props$portalContaine = props.portalContainer) !== null && _props$portalContaine !== void 0 ? _props$portalContaine : document.body));
}

//#endregion
export { DocSearch, DocSearchAI, DocSearchAIInner, DocSearchAskAiModal, DocSearchButton, DocSearchInner, DocSearchModal, useDocSearchKeyboardEvents, version };
//# sourceMappingURL=index.js.map